import ResponsiveHeight from 'responsive-height';

export default () => {
    const singleContainers = document.querySelectorAll('.icon-grid--single .icon-grid__items');
    const separateContainers = document.querySelectorAll('.icon-grid--separate .icon-grid__items');

    for (const el of singleContainers) {
        new ResponsiveHeight(el, {
            child: '.icon-grid__topper',
            widths: [[0, 3]],
        });
    }

    for (const el of separateContainers) {
        new ResponsiveHeight(el, {
            child: '.icon-grid__topper',
            widths: [[0, 2]],
        });
    }
};
